const listjs = require('list.js');
import 'alpinejs';
import '@kingshott/iodine';
import Splide from '@splidejs/splide';

function setSplideTabActive(tabs, index) {
  [].forEach.call(tabs, (tab, idx) => {
    tab.classList.remove('button--primary');

    if (idx === index) {
      tab.classList.add('button--primary');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.splide');

  [].forEach.call(sliders, (slider) => {
    const splideInstance = new Splide(slider, {
      type: 'loop',
      autoplay: false,
    }).mount();

    let target = slider;
    let tabElement;
    let depth = 0;

    if (!slider.classList.contains('splide-with-tabs')) {
      return;
    }

    // find tabs
    while (target && depth < 3) {
      depth++;

      tabElement = target.querySelector('.splide-tabs');

      // we've found our tabs for this splide instance
      if (tabElement && tabElement.length > 0) {
        target = null;
      }

      target = target.parentElement;
    }

    if (tabElement) {
      const tabs = tabElement.querySelectorAll('button');

      splideInstance.on('moved', (newIndex) => {
        console.log('moved', newIndex, slider);
        setSplideTabActive(tabs, newIndex);
      });

      [].forEach.call(tabs, (tab) => {
        tab.addEventListener('click', () => {
          let id = tab.getAttribute('data-id');

          if (id != null) {
            id = parseInt(id, 10);
          }

          splideInstance.go(id);

          setSplideTabActive(tabs, id);
        });
      });
    }
  });
});

let shuffleElement = document.querySelector('.js-list');
var list;

if (shuffleElement) {
  var options = {
    valueNames: [
      { name: 'jobType', attr: 'data-jobtype' },
      { name: 'location', attr: 'data-location' },
      { name: 'category', attr: 'data-category' },
    ],
  };

  list = new listjs(shuffleElement, options);
}

var activeFilters = {
  jobType: undefined,
  location: undefined,
  category: undefined,
};

window.filterListBy = function (key, value) {
  activeFilters[key] = value;

  if (list == null) {
    return;
  }

  list.filter(function (item) {
    const resetValue = '-1';
    const values = item.values();

    if (value === resetValue) {
      return true;
    }

    const isMatchJobType =
      activeFilters['jobType'] != null
        ? values['jobType'].indexOf(activeFilters['jobType']) > -1
        : undefined;
    const isMatchLocation =
      activeFilters['location'] != null
        ? values['location'].indexOf(activeFilters['location']) > -1
        : undefined;
    const isMatchCategory =
      activeFilters['category'] != null
        ? values['category'].indexOf(activeFilters['category']) > -1
        : undefined;

    if (
      (isMatchJobType == null || isMatchJobType) &&
      (isMatchLocation == null || isMatchLocation) &&
      (isMatchCategory == null || isMatchCategory)
    ) {
      return true;
    } else {
      return false;
    }
  });
};

Iodine.addRule('defined', function (value) {
  return (
    value !== 'undefined' &&
    value != null &&
    value != undefined &&
    value.trim() !== ''
  );
});

Iodine.setErrorMessages({
  after: `The date must be after: '[PARAM]'`,
  afterOrEqual: `The date must be after or equal to: '[PARAM]'`,
  array: `Value must be an array`,
  before: `The date must be before: '[PARAM]'`,
  beforeOrEqual: `The date must be before or equal to: '[PARAM]'`,
  boolean: `Value must be true or false`,
  date: `Ungültiges Datum`,
  different: `Value must be different to '[PARAM]'`,
  endingWith: `Value must end with '[PARAM]'`,
  email: `Eingabe muss eine gültige E-Mail Adresse sein`,
  falsy: `Value must be a falsy value (false, 'false', 0 or '0')`,
  in: `Value must be one of the following options: [PARAM]`,
  integer: `Value must be an integer`,
  json: `Value must be a parsable JSON object string`,
  maximum: `Value must not be greater than '[PARAM]' in size or character length`,
  minimum: `Value must not be less than '[PARAM]' in size or character length`,
  notIn: `Value must not be one of the following options: [PARAM]`,
  numeric: `Value must be numeric`,
  optional: `Value is optional`,
  regexMatch: `Value must satisify the regular expression: [PARAM]`,
  required: `Dieses Feld ist ein Pflichtfeld`,
  same: `Value must be '[PARAM]'`,
  startingWith: `Value must start with '[PARAM]'`,
  string: `Value must be a string`,
  truthy: `Value must be a truthy value (true, 'true', 1 or '1')`,
  url: `Value must be a valid url`,
  defined: `Dieses Feld ist ein Pflichtfeld`,
});
